import React from "react";
import styled from "@emotion/styled";
import { theme } from "../../utils/theme";

const ButtonMain = styled("button")`
  padding: 0.5rem 1rem;
  background-color: ${theme.colors.secondary};
  border: 1px solid #ffffff4d;
  color: #fff;
  cursor: pointer;
`;

const Button = ({ value, onClickHandle }) => {
  return (
    <ButtonMain className="btn" type="button" onClick={onClickHandle}>
      {value}
    </ButtonMain>
  );
};

export default Button;
